export var Invitee = function(inviteeData) {
    var invitee = {};
    
    // Constructor
    if (inviteeData) {

    }

    // -----------------------------------------------------
    //
    //                 Public Methods
    //
    // -----------------------------------------------------
    
    // -----------------------------------------------------
    //
    //                 Private Methods
    //
    // -----------------------------------------------------
    
    return invitee;
};



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/models/invitee.js
// module id = 355
// module chunks = 0